import AOS from "aos";
import "aos/dist/aos.css";
import React, { useContext, useEffect } from 'react';

import PropTypes from 'prop-types';
import { ThemeContext } from "../App";
import "../css/about.scss";

const About = ({ data }) => {
  useEffect(() => {
    AOS.init();
  }, []);


  const { theme } = useContext(ThemeContext);
  
  return (
    <>
      <div className='about-body' id='about'>
        <div className='about-title'>
          <span className="text">{data.title}</span>
        </div>
        <div className='about-container'>
          <div className='about-img-container'
            data-aos='fade-right'>
            <img alt='img' className='about-img' src={data.image} />
          </div>
          <div className='about-text' data-aos='fade-left'>
            <div data-aos='fade-left' className=''>
              {data.introduction}
            </div>
            <div className='purpose-title'>{data.purpose}:</div>
            <ul>
              <li data-aos='fade-left'>
                {data.textOne}
              </li>
              <li data-aos='fade-left'>
                {data.textTwo}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className='operations'>
        <div className='operations-title'>{data.titletwo}</div>

        <div className='operations-list' data-aos='fade-up'>
          <div data-aos='fade-right'>
            {data.servicesTextOne}
          </div>
          <br />
          <div data-aos='fade-right'>
            {data.servicesTextTwo}
          </div>
          <br />
          <div data-aos='fade-right'>
            {data.servicesTextThree}
          </div>
        </div>
      </div>

      <div className='greeting'>
          <div className='greeting-left'>
            <div className='greeting-title'>
              <span className="text">{data.greetingTitle}</span>
            </div>
            <div className='greeting-text'>{data.greetingText}</div>
            <div className='greeting-name'>
              <strong>{data.greetingName}</strong>
            </div>
            <div className='greeting-name-title'>{data.greetingPosition}</div>
            <div className='greeting-name-title'>{data.greetingNameTitle}</div>
          </div>
          <div className='greeting-right'>
            <div className="img"></div>
          </div>
      </div>
    </>
  );
};

About.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.string,
    introduction: PropTypes.string,
    purpose: PropTypes.string,
    textOne: PropTypes.string,
    textTwo: PropTypes.string,
    titletwo: PropTypes.string,
    paragraphOne: PropTypes.string,
    paragraphTwo: PropTypes.string,
    servicesTextOne: PropTypes.string,
    servicesTextTwo: PropTypes.string,
    servicesTextThree: PropTypes.string,
    paragraphThree: PropTypes.string,
    paragraphFour: PropTypes.string,
  }).isRequired,
};
export default About;
